module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0e7c63d93e28be97a36696f8a1528c4c.jpg";